<template>
	<ja-modal :show="show" class="info-modal">
		<ja-close-button
			name="close"
			@click.native="closeModal()"
		></ja-close-button>
		<div class="modal-content">
			<h3 v-if="hasTitle" class="modal__title heading-3">{{ title }}</h3>
			<perfect-scrollbar class="content">
				<slot></slot>
			</perfect-scrollbar>
		</div>

		<div v-if="hasButtons" class="btn-group btn-group--center">
			<ja-button name="confirm" class="small primary" @click.native="confirm()">
				{{ confirmText || $t('ok') }}
			</ja-button>
			<ja-button
				v-if="hasCancel"
				name="cancel"
				class="small outlined"
				@click.native="cancel()"
			>
				{{ cancelText || $t('cancel') }}
			</ja-button>
		</div>
	</ja-modal>
</template>

<script>
import Modal from '@/components/Modal/Modal';
import { CloseButton, Button } from '@ui';

export default {
	components: {
		jaModal: Modal,
		jaCloseButton: CloseButton,
		jaButton: Button
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: 'Information'
		},
		hasButtons: {
			type: Boolean,
			default: true
		},
		hasCancel: {
			type: Boolean,
			default: true
		},
		hasTitle: {
			type: Boolean,
			default: true
		},
		cancelText: {
			type: String,
			default: ''
		},
		confirmText: {
			type: String,
			default: ''
		}
	},
	methods: {
		closeModal() {
			this.$emit('closeModal');
		},
		confirm() {
			this.$emit('confirm');
		},
		cancel() {
			this.$emit('cancel');
		}
	}
};
</script>
